const config = process.env;

export default config;
